import { render, staticRenderFns } from "./LiveAgentMessageNew.vue?vue&type=template&id=162c32aa"
import script from "./LiveAgentMessageNew.vue?vue&type=script&lang=ts"
export * from "./LiveAgentMessageNew.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports